import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const AiAssistantView = React.lazy(() => import("./AiAssistant.view"));

const AiAssistantLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <AiAssistantView />
  </React.Suspense>
);

export default () => <AiAssistantLoadable />;
